import { Context } from './types'

export const context: Context = {}
